import React, { useState } from "react";
import "./ReviewsSection.css";
import { Link } from "react-router-dom";
import craftedBannerImg from "../../../assets/images/CRAFTED-WITH-PASSION.png";

/* ── Static review data ── */
const REVIEWS = [
  {
    id: 1,
    name: "Ayesha Khan",
    location: "Karachi",
    rating: 5,
    text: '"Absolutely stunning jewellery! The quality is exceptional and the packaging was so elegant. Highly recommended!"',
    avatar: null,
    initials: "AK",
  },
  {
    id: 2,
    name: "Sana Malik",
    location: "Lahore",
    rating: 5,
    text: '"I bought a necklace for my sister and she loved it! The design is so unique and classy. Will definitely shop again."',
    avatar: null,
    initials: "SM",
  },
  {
    id: 3,
    name: "Sara Ahmed",
    location: "Islamabad",
    rating: 5,
    text: '"Beautiful collection and very professional service. Delivery was on time and the jewellery exceeded my expectations."',
    avatar: null,
    initials: "SA",
  },
  {
    id: 4,
    name: "Hira Baig",
    location: "Dubai",
    rating: 5,
    text: '"The craftsmanship is incredible. Every piece tells a story. I have already placed my second order!"',
    avatar: null,
    initials: "HB",
  },
  {
    id: 5,
    name: "Nadia Farooq",
    location: "London",
    rating: 5,
    text: '"Received so many compliments on my bracelet. The gold finish is flawless and it arrived beautifully packaged."',
    avatar: null,
    initials: "NF",
  },
];

/* ── Star renderer ── */
function Stars({ count = 5 }) {
  return (
    <div className="rvs-stars" aria-label={`${count} out of 5 stars`}>
      {Array.from({ length: 5 }, (_, i) => (
        <svg
          key={i}
          className={`rvs-star${i < count ? " rvs-star--filled" : ""}`}
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.49L10 14.27l-4.94 2.43.94-5.49-4-3.9 5.53-.8z" />
        </svg>
      ))}
    </div>
  );
}

/* ── Avatar placeholder ── */
function Avatar({ initials, src, name }) {
  return src ? (
    <img className="rvs-avatar" src={src} alt={name} loading="lazy" />
  ) : (
    <div className="rvs-avatar rvs-avatar--initials" aria-hidden="true">
      {initials}
    </div>
  );
}

/* ── Main component ── */
export default function ReviewsSection() {
  const VISIBLE = 3;
  const [start, setStart] = useState(0);

  const total = REVIEWS.length;
  const visible = REVIEWS.slice(start, start + VISIBLE);

  const prev = () => setStart((s) => (s - 1 + total) % total);
  const next = () => setStart((s) => (s + 1) % total);

  /* Wrap-around: if slice < VISIBLE, pad from start */
  const cards =
    visible.length < VISIBLE
      ? [...visible, ...REVIEWS.slice(0, VISIBLE - visible.length)]
      : visible;

  return (
    <section className="rvs-root" aria-label="Customer reviews">

      {/* ── REVIEWS PANEL ── */}
      <div className="rvs-panel">

        {/* Header */}
        <div className="rvs-header">
          {/* Divider label */}
          <div className="rvs-eyebrow">
            <span className="rvs-eyebrow-line" />
            <span className="rvs-eyebrow-text">WHAT OUR CUSTOMERS SAY</span>
            <span className="rvs-eyebrow-line" />
          </div>

          <h2 className="rvs-title">
            REAL REVIEWS,{" "}
            <em className="rvs-title-em">REAL STORIES</em>
          </h2>

          <p className="rvs-subtitle">
            Our customers' happiness means everything to us.
          </p>

          {/* Nav arrows */}
          <div className="rvs-nav">
            <button
              className="rvs-nav-btn"
              onClick={prev}
              aria-label="Previous reviews"
            >
              &#8249;
            </button>
            <button
              className="rvs-nav-btn"
              onClick={next}
              aria-label="Next reviews"
            >
              &#8250;
            </button>
          </div>
        </div>

        {/* Cards row */}
        <div className="rvs-cards">
          {cards.map((r, idx) => (
            <article key={`${r.id}-${idx}`} className="rvs-card">
              <div className="rvs-card-top">
                <Avatar initials={r.initials} src={r.avatar} name={r.name} />
                <Stars count={r.rating} />
              </div>
              <p className="rvs-card-text">{r.text}</p>
              <footer className="rvs-card-footer">
                <span className="rvs-card-name">{r.name}</span>
                <span className="rvs-card-location">{r.location}</span>
              </footer>
            </article>
          ))}
        </div>
      </div>

      {/* ── CRAFT BANNER (IMAGE) ── */}
      <div className="rvs-craft-banner-wrap">
        <Link
          to={`${process.env.PUBLIC_URL}/about-us`}
          className="rvs-craft-banner-link"
          aria-label="About SHANZ BY SHANZAY - Crafted With Passion"
        >
          <img
            src={craftedBannerImg || `${process.env.PUBLIC_URL}/CRAFTED-WITH-PASSION.png`}
            alt="SHANZ BY SHANZAY - Crafted With Passion"
            className="rvs-craft-banner-img"
            loading="lazy"
          />
        </Link>
      </div>

    </section>
  );
}
